import React, { Component } from 'react';
import { translate } from 'react-i18next';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';

import './Button.css';

declare var CONFIGURATIONS;


class Button extends Component {

	render() {
		const { text, active, onClick, onClick2, onClick3, text1, text2, text3, active2, active3, children, number } = this.props;
		if (text1 !== undefined && text2 !== undefined && text3 !== undefined) {
			return (
				<DropdownMenu trigger={text} testId='dropdown-button' zIndex={99999999}>
					<DropdownItemGroup>
						<DropdownItem onClick={onClick} isDisabled={!active}>{text1}</DropdownItem>
						<DropdownItem onClick={onClick2} isDisabled={!active2}>{text2}</DropdownItem>
						<DropdownItem onClick={onClick3} isDisabled={!active3}>{text3}</DropdownItem>
					</DropdownItemGroup>
				</DropdownMenu>
			);
    } else {
      let style = {
        color: 'white',
        backgroundColor: '#006699',
      };

      if (active === false) {
        style.color = '#006699';
        style.backgroundColor = '#e6e6e6';
      }

      return (
        <div className='underListButton' tabIndex={number !== undefined ? (number - 1) : 0} role='button' onClick={active !== false ? onClick : undefined} style={style}>
          {text}
					{children}
        </div>
      );
    }
	}
}

export default translate()(Button);
